import { render, staticRenderFns } from "./Mouth.vue?vue&type=template&id=7d5a3e62&"
import script from "./Mouth.vue?vue&type=script&lang=js&"
export * from "./Mouth.vue?vue&type=script&lang=js&"
import style0 from "./Mouth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports